// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

import {
  DEFAULT_TRANSLATION_DESKTOP,
  DEFAULT_TRANSLATION_MOBILE,
  ITEM_DESKTOP_FULL_WIDTH,
  ITEM_DESKTOP_HEIGHT,
  ITEM_DESKTOP_MARGIN,
  ITEM_DESKTOP_WIDTH,
  ITEM_MOBILE_FULL_WIDTH,
  ITEM_MOBILE_HEIGHT,
  ITEM_MOBILE_MARGIN,
  ITEM_MOBILE_WIDTH,
} from './constants';

export const Wrapper = styled.div`
  height: 412px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    height: 400px;
  }
`;

export const ItemContainer = styled.div<{ isSelected: boolean }>`
  position: relative;
  border-radius: 10px;
  width: ${ITEM_MOBILE_WIDTH}px;
  margin-right: ${ITEM_MOBILE_MARGIN}px;
  height: ${ITEM_MOBILE_HEIGHT}px;
  background: rgba(0, 0, 0, 0.7);

  will-change: transform;
  transform: ${({ isSelected }) => (isSelected ? 'scale(1.2)' : 'scale(0.9)')};
  z-index: ${({ isSelected }) => (isSelected ? 3 : 2)};
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.3)};
  transition: 0.3s;
  ::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 10px;
  }
  ::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 10px;
    z-index: -1;
    box-shadow: ${({ isSelected }) =>
      isSelected ? ' 0px 0px 24px rgba(255, 255, 255, 0.22);' : 'none'};
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: ${ITEM_DESKTOP_WIDTH}px;
    margin-right: ${ITEM_DESKTOP_MARGIN}px;
    height: ${ITEM_DESKTOP_HEIGHT}px;
  }
`;

export const SliderContainer = styled.div`
  width: ${ITEM_MOBILE_FULL_WIDTH * 3 - ITEM_MOBILE_MARGIN}px;
  max-width: 100%;
  box-sizing: content-box;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: ${ITEM_DESKTOP_FULL_WIDTH * 3 - ITEM_DESKTOP_MARGIN}px;
  }
`;

export const DraggableContentContainer = styled.div<{
  translateX: number | 'default';
}>`
  transform: translateX(
    ${({ translateX }) =>
      translateX === 'default' ? DEFAULT_TRANSLATION_MOBILE : translateX}px
  );
  ${({ theme }) => theme.breakpoints.up('sm')} {
    transform: translateX(
      ${({ translateX }) =>
        translateX === 'default' ? DEFAULT_TRANSLATION_DESKTOP : translateX}px
    );
  }
  will-change: transform;
  transition: 0.3s;
`;
